module.exports = "/static/assets/7597269cc47cd288d56fc20bf1075091.png";